export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const ANY_ENTITY = '0xffffffffffffffffffffffffffffffffffffffff'
export const NO_MANAGER = '0x0000000000000000000000000000000000000000'

export const ARAGON_DOMAIN = 'aragonid.eth'
export const DEFAULT_APM_REGISTRY = 'aragonpm.eth'

export const DEFAULT_IPFS_TIMEOUT = 300000

export const REGISTRAR_GAS_LIMIT = '1000000'
export const DEFAULT_GAS_FUZZ_FACTOR = 1.5
export const LAST_BLOCK_GAS_LIMIT_FACTOR = 0.95
export const DEFAULT_GAS_PRICE = '5000000000' // 5 gwei

export const EXECUTE_FUNCTION_NAME = 'execute'

export const APM_INITIAL_VERSIONS = ['0.0.1', '0.1.0', '1.0.0']

export const MANIFEST_FILE = 'manifest.json'
export const ARTIFACT_FILE = 'artifact.json'
export const SOLIDITY_FILE = 'code.sol'
export const ARAPP_FILE = 'arapp.json'

export const LATEST_VERSION = 'latest'

export const FRAME_ENDPOINT = 'ws://localhost:1248'
export const FRAME_ORIGIN = 'aragonCLI'

export const ARAGON_RINKEBY_ENDPOINT = 'wss://rinkeby.eth.aragon.network/ws'
export const ARAGON_MAINNET_ENDPOINT = 'wss://mainnet.eth.aragon.network/ws'

export const IPFS_RPC = 'http://localhost:5001#default'

export const IPFS_LOCAL_GATEWAY = 'http://localhost:8080/ipfs'
export const IPFS_ARAGON_GATEWAY = 'https://ipfs.eth.aragon.network/ipfs'

export const DEVCHAIN_ENS = '0x5f6f7e8cc7346a11ca2def8f827b7a0b612c56a1'
